export const regexBase64 =
  /^([0-9a-z+/]{4})*(([0-9a-z+/]{2}==)|([0-9a-z+/]{3}=))?$/i;

export const regexUUID = /^[0-9a-f]{8}\b(?:-[0-9a-f]{4}\b){3}-[0-9a-f]{12}$/i;

export const regexSchemaId = /^http.*schemas\/(.+)\.json$/;
